<div class="direction" *ngIf="isStarted">
    <div class="arrow-wrap">
        <mat-icon (click)="previous()">chevron_left</mat-icon>
    </div>
    <div class="steps">
        <div [innerHtml]="direction"></div>
        <p>{{time}}</p>
        <p>{{distance}}</p>
    </div>
    <div class="arrow-wrap">
        <mat-icon (click)="next()">chevron_right</mat-icon>
    </div>

</div>

<div class="direction-trigger" [class.disabled]="!isReady">
    <button *ngIf="!isStarted" (click)="startOrStopPlan()" [class.start]="isStarted" class="start-plan-btn">
        GPS Directions
    </button>
    <ng-container>
        <button *ngIf="!isStarted&&canSetDefaultTravelMode" #defaultTravelModeMenuTrigger="matMenuTrigger"
            [matMenuTriggerFor]="defaultModeMenu" class="start-plan-btn m-l-3">
            Set Default Travel Mode
        </button>
        <button *ngIf="canChangeTravelModeOnFrontend" #defaultTravelModeMenuTrigger="matMenuTrigger"
            [matMenuTriggerFor]="defaultModeMenu" class="start-plan-btn m-l-3">
            Change Travel Mode
        </button>
    </ng-container>
    <ig-button (trigger)="stopPlan()" *ngIf="isStarted" class="red-btn">End Plan</ig-button>

    <mat-menu [yPosition]="'above'" #defaultModeMenu="matMenu">
        <mat-radio-group class="default-mode-group" (click)="$event.stopPropagation()" [(ngModel)]="travelMode">
            <mat-radio-button style="display: block;padding:6px 24px" [value]="'DRIVING'"
                (change)="onTravelModeChange()">
                Driving
            </mat-radio-button>
            <mat-radio-button style="display: block;padding:6px 24px" [value]="'BICYCLING'"
                (change)="onTravelModeChange()">
                Biking
            </mat-radio-button>
            <mat-radio-button style="display: block;padding:6px 24px" [value]="'WALKING'"
                (change)="onTravelModeChange()">
                Walking
            </mat-radio-button>
        </mat-radio-group>

        <ng-container *ngIf="canSetDefaultTravelMode">
            <hr>

            <mat-checkbox style="padding: 0 12px" [(ngModel)]="canChangeTravelMode"
                (click)="$event.stopPropagation()">Can user view other modes?
            </mat-checkbox>

            <ig-button style="margin:8px 12px" size="md" (trigger)="setDefaultTravelMode()">save</ig-button>
        </ng-container>

    </mat-menu>

</div>

<agm-map #map [styles]="hideIconMapStyler" [zoomControlOptions]="zoomOptions"
    [streetViewControlOptions]="streetViewOptions" [clickableIcons]="false" [latitude]="lat" [longitude]="lng"
    [mapTypeId]="'terrain'" [zoom]="getZoom" [fitBounds]="latLngBounds" (mapClick)="onMapClick()">
    <agm-direction [visible]="!!directions" *ngIf="!!directions" [origin]="directions.origin"
        [destination]="directions.destination" [travelMode]="travelMode" [waypoints]="directions.waypoints"
        [renderOptions]="directions.options" [optimizeWaypoints]="false">
    </agm-direction>
    <agm-marker *ngFor="let geo of tour.attractions; let i = index"
        [iconUrl]="imageService.imageSourceUrl(tripPlannerMapMarker)" [latitude]="geo.item.address.lat||geo.item.lat"
        [longitude]="geo.item.address.lng||geo.item.lng" (mouseOver)="showInfoWindowByIndex(i)"
        (markerClick)="showInfoWindowByIndex(i)" [label]="(i+1).toString()" [zIndex]="i">

        <agm-snazzy-info-window *ngIf="!isMobile" [isOpen]="isInfoWindowsOpen[i]&&!isMobile"
            [closeWhenOthersOpen]="true" (afterClose)="hideAllSingleInfoWindow()">
            <ng-template>
                <div style="position: relative">
                    <div class="map-event-title">
                        {{geo.item.name||geo.item.title}}
                    </div>
                    <div class="map-event-img">
                        <img [src]="imageService.safeImage(imageService.imageSource(geo.item))" alt="item">
                    </div>
                    <div class="map-event-time">
                        <div *ngIf="geo.item.eventTimes&&geo.item.eventTimes.length>1">
                            <ng-container *ngIf="!geo.item.startTimeText">
                                <p *ngFor="let eventTime of geo.item.eventTimes">
                                    {{eventTime.startTimeFormatted}}{{eventTime.endTimeFormatted?' -
                                    '+eventTime.endTimeFormatted:''}}
                                </p>
                            </ng-container>
                            <ng-container *ngIf="geo.item.startTimeText">
                                <p *ngFor="let eventTime of geo.item.eventTimesText">
                                    {{eventTime.startTimeText+' '+geo.item.timezone}}{{eventTime.endTimeText?'
                                    -
                                    '+eventTime.endTimeText+' '+geo.item.timezone:''}}
                                </p>
                            </ng-container>

                        </div>
                        <div *ngIf="!geo.item.eventTimes||geo.item.eventTimes.length<=1">
                            <ng-container *ngIf="!geo.item.startTimeText">
                                {{geo.item.startTimeFormatted}}{{geo.item.endTimeFormatted?' -
                                '+geo.item.endTimeFormatted:''}}
                            </ng-container>
                            <ng-container *ngIf="geo.item.startTimeText">
                                {{geo.item.startTimeText+' '+geo.item.timezone}}{{geo.item.endTimeText?' -
                                '+geo.item.endTimeText+' '+geo.item.timezone:''}}
                            </ng-container>
                        </div>
                        <div *ngIf="!geo.item.startTime&&geo.item.address">
                            {{geo.item.address?.address||geo.item.address}}
                        </div>
                    </div>
                    <ig-button class="event-btn" (trigger)="gotoDetails(geo.item)">
                        DETAILS
                    </ig-button>
                </div>
            </ng-template>
        </agm-snazzy-info-window>
    </agm-marker>
</agm-map>

<ig-trip-map-bottom-info #mapBottomInfo *ngIf="!isNullOrUndefined(currentIndex)&&isMobile"
    [item]="tour.attractions[currentIndex].item" [isShowRemoveBtn]="type==='trip'" [index]="currentIndex"
    (showDetail)="gotoDetails(tour.attractions[currentIndex].item)"
    (removeFromTrip)="remove(tour.attractions[currentIndex].item)"></ig-trip-map-bottom-info>

<div #banner class="ig-map-banner">Hey there, this is your first trip! To edit your stops, <span
        (click)="enterFirstTripTrigger($event)" role="button" aria-label="edit my trips">click here</span>.</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/tours/direction.plan/direction.plan.component.html